import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import DashboardNavbar from "../components/DashboardNavbar";
import { useAuth } from "../context/AuthContext";
import NavTabs from "../components/NavTabs";
 
export default function DashboardPage() {
  const [firstName, setFirstName] = useState("User");
  const [mobileOpen, setMobileOpen] = useState(false);
 
  // NEW — sidebar expand state from NavTabs (desktop)
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
 
  const { user, logout, isLoading } = useAuth();
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!isLoading) {
      if (user && user.firstName) {
        setFirstName(user.firstName);
      } else {
        setFirstName("User");
      }
    }
  }, [user, isLoading]);
 
  const handleLogout = () => {
    logout();
    navigate("/login");
  };
 
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen font-sans bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center"
        >
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent mb-4"></div>
          <p className="text-gray-600 font-medium">Loading user data...</p>
        </motion.div>
      </div>
    );
  }
 
  return (
    <div className="flex flex-col h-screen font-sans bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20">

      {/* ---------- FIXED TOP NAVBAR ---------- */}
      <motion.div 
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="fixed top-0 left-0 right-0 z-50 h-24 bg-white/90 backdrop-blur-md shadow-lg border-b border-gray-200/50"
      >
        <DashboardNavbar onMenuClick={() => setMobileOpen(true)} />
      </motion.div>
      {/* ---------- PAGE WRAPPER (after navbar) ---------- */}
      <div className="flex flex-1 pt-24">
 
        {/* ---------- DESKTOP SIDEBAR (COLLAPSIBLE) ---------- */}
        <motion.aside
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="
            hidden md:flex
            flex-col
            bg-gradient-to-b from-gray-800 via-gray-900 to-gray-800
            text-white
            h-[calc(100vh-6rem)]
            fixed
            top-24
            left-0
            transition-all
            duration-300
            shadow-2xl
            border-r border-gray-700/50
            overflow-y-auto
            z-40
          "
          style={{
            width: sidebarExpanded ? 256 : 80,
          }}
        >
          <NavTabs
            isMobile={false}
            onSidebarStateChange={(state) => setSidebarExpanded(state)}
          />
        </motion.aside>
 
        {/* ---------- MOBILE SIDEBAR ---------- */}
        <AnimatePresence>
          {mobileOpen && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden"
                onClick={() => setMobileOpen(false)}
              />
              <NavTabs
                isMobile={true}
                onLinkClick={() => setMobileOpen(false)}
              />
            </>
          )}
        </AnimatePresence>
 
        {/* ---------- MAIN CONTENT AREA ---------- */}
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className={`
            flex-1 p-4 overflow-auto transition-all duration-300
            ${sidebarExpanded ? "md:ml-64" : "md:ml-20"}
          `}
        >
          <Outlet />
        </motion.main>
 
      </div>
    </div>
  );
}